import { render, staticRenderFns } from "./BazarConfirmar.vue?vue&type=template&id=63a72b82&"
import script from "./BazarConfirmar.vue?vue&type=script&lang=js&"
export * from "./BazarConfirmar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports